import { FC } from 'react';
import FormGroup from 'components/form/FormGroup';
import FormRowGroup from 'components/form/FormRowGroup';
import Form from 'components/form/Form';
import { useHistory, useParams } from 'react-router';
import { useActiveClientContext } from 'store/active-client';
import { buildClientUrl } from 'utils/helpers/client';
import { ISelectOptionProps } from 'components/form/types';
import { IInputs } from '../types';

interface IProps {
  methods: any;
  handleSubmit: (data: IInputs) => void;
  btnLabel: string;
  showBackBtn?: boolean;
  isMultilingual?: boolean | null;
  identifierOptions?: ISelectOptionProps[];
}

const ElementForm: FC<IProps> = ({ methods, handleSubmit, btnLabel, isMultilingual, identifierOptions }: IProps) => {
  const { segmentId } = useParams<{ segmentId: string }>();
  const history = useHistory();
  const { client } = useActiveClientContext();

  return (
    <Form
      methods={methods}
      onSubmit={handleSubmit}
      btnLabel={btnLabel}
      onCancel={() => history.push(buildClientUrl(`/segments/edit/${segmentId}`, client))}
      isHorizontal
    >
      {isMultilingual ? (
        <FormRowGroup>
          <FormGroup
            controlId="formGroupName"
            label="Име на елемента"
            type="text"
            name="name"
            isRequired
            isRowGroup
          />
          <FormGroup
            controlId="formGroupNameEn"
            label="Element name"
            type="text"
            name="name_en"
            isRowGroup
          />
        </FormRowGroup>
      ) : (
        <FormGroup
          controlId="formGroupName"
          label="Име на елемента"
          type="text"
          name="name"
          isRequired
          isHorizontal
        />
      )}
      <FormGroup
        controlId="formIdentifierSubType"
        label="Тип на идентификатора"
        type="select"
        as="select"
        name="identifier"
        isClearable
        isHorizontal
        showTotal
        selectOptions={identifierOptions}
      />
      <FormGroup
        controlId="formGroupContent"
        label="Съдържание на елемента"
        type="wysiwyg-editor"
        name="contents"
        isRequired
        isHorizontal
        disableLocalization
      />
      {isMultilingual && (
        <FormGroup
          controlId="formGroupContentEn"
          label="Element content"
          type="wysiwyg-editor"
          name="contents_en"
          isHorizontal
          disableLocalization
        />
      )}
      <FormGroup
        controlId="formGroupStatus"
        label="Активно"
        checkType="switch"
        name="is_active"
        isRequired
        isHorizontal
      />
    </Form>
  );
};

export default ElementForm;
